/*
 * gm-disable-devtools.js
 * -----------------------------------------------------------------------------
 * Deters casual access to browser DevTools / "Inspect Element":
 *   - Blocks the right-click context menu
 *   - Blocks F12
 *   - Blocks Ctrl/Cmd+Shift+I / J / C (DevTools & element picker)
 *   - Blocks Ctrl/Cmd+U (view source)
 *
 * IMPORTANT: This is a deterrent only. It CANNOT truly prevent inspection —
 * the page is client-side, so a determined user can disable JavaScript, open
 * DevTools from the browser menu, or use view-source:. Remove the <script> tag
 * in layout/theme.liquid to disable this entirely.
 */
(function () {
  'use strict';

  // Block right-click → Inspect
  document.addEventListener(
    'contextmenu',
    function (e) {
      e.preventDefault();
    },
    { capture: true }
  );

  // Block keyboard shortcuts that open DevTools / view source
  document.addEventListener(
    'keydown',
    function (e) {
      var key = (e.key || '').toLowerCase();
      var ctrlOrCmd = e.ctrlKey || e.metaKey;

      // F12
      if (key === 'f12') {
        e.preventDefault();
        return false;
      }

      // Ctrl/Cmd+Shift+I (Inspect), +J (Console), +C (element picker)
      if (ctrlOrCmd && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) {
        e.preventDefault();
        return false;
      }

      // Ctrl/Cmd+U (View source)
      if (ctrlOrCmd && key === 'u') {
        e.preventDefault();
        return false;
      }
    },
    { capture: true }
  );
})();
